const LANGUAGE = {
  ENGLISH: "en",
  SERBIAN: "sr"
};

export default LANGUAGE;
